/**
 * CanvasLayer parser. CanvasLayer is not a Control, so it parses only the heading's
 * hierarchy attributes, visibility, layer, its canvas transform and how it follows the viewport. Without its `parent` a node
 * attaches to nothing, and a scene has one root, so the layer and its subtree would be dropped.
 */
import { boolOr, floatOr, parseOptionalInt, parseHeadingIndex, vec2Or, } from '../../../../parser/valueParsers';
import { decomposeTransform2D } from '../../../base/node2d/parser';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
import { transform2DFromParts } from '../../../../godot/math/transform2d.js';
/**
 * The layer's canvas transform, shared with every CanvasLayer subclass. `_bind_methods` registers
 * `transform` after offset, rotation and scale (`canvas_layer.cpp:343-346`), so Godot writes it
 * last and `set_transform` stores the whole matrix, skew included.
 */
export function parseCanvasLayerTransform(properties, name) {
    const parts = properties.transform ? decomposeTransform2D(properties.transform, name) : null;
    if (parts)
        return transform2DFromParts(parts.rotation, parts.scale, parts.skew, parts.position);
    const context = name || 'CanvasLayer';
    return transform2DFromParts(floatOr(properties.rotation, 0, context), vec2Or(properties.scale, { x: 1, y: 1 }, context), 0, vec2Or(properties.offset, { x: 0, y: 0 }, context));
}
export function parseCanvasLayer(heading, properties) {
    const name = heading.attributes.name || '';
    const context = name || 'CanvasLayer';
    const result = {
        name,
        canvasTransform: parseCanvasLayerTransform(properties, name),
        follow_viewport_enabled: boolOr(properties.follow_viewport_enabled, false, context),
        follow_viewport_scale: floatOr(properties.follow_viewport_scale, 1, context),
    };
    if (heading.attributes.parent !== undefined)
        result.parent = heading.attributes.parent;
    if (heading.attributes.instance !== undefined)
        result.instance = heading.attributes.instance;
    const index = parseHeadingIndex(heading.attributes.index);
    if (index !== undefined)
        result.index = index;
    if (properties.visible !== undefined)
        result.visible = boolSlotValue(properties.visible) !== false;
    const layer = parseOptionalInt(properties.layer);
    if (layer !== undefined)
        result.layer = layer;
    return result;
}
//# sourceMappingURL=parser.js.map